module.exports = __webpack_public_path__ + "img/en-2-3.e8754583.png";